// utils/index.js's request() resolves failed calls instead of rejecting (it catches axios
// errors and returns error.response), so react-query's own isError/onError never fires for an
// HTTP failure — callers must check the resolved response shape themselves.
export function isFailedResponse(res) {
    return !res || (res.status && res.status >= 400);
}
